import { Navigate } from 'react-router-dom';
import { ReactNode, useEffect } from 'react';
import { useStore } from '../../hooks/useStore';

interface PrivateRouteProps {
  children: ReactNode;
  requiredRoles?: string[];
}

export const PrivateRoute = ({ children, requiredRoles }: PrivateRouteProps) => {
  const { authStore } = useStore();
  if (!authStore.isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requiredRoles && !authStore.hasAnyRole(requiredRoles)) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};
